import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Landing from "@/pages/Landing";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
      </Routes>
    </BrowserRouter>
  );
}
